/*global chrome*/
import React from 'react';
import { Link} from 'react-router-dom';
import Slider from "react-slick";
class coursesWeOffer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            homePage:false
        }
    }
    componentDidMount() {
    }
 render(){  
	return (
		<section className="coursesOffer">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2 className="secondary-heading">Courses <span>we offer</span></h2>
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div className='courseOuter'>
                  <div className="courseCntnt">
                    <div>
                      <p>PTE</p>
                      <Link to="/pte-coaching-classes-parramatta" className="primary-border-btn">VIEW COURSE <img className="arrow-icon" src="/images/web-new-images/icons/right-arrow.png" alt="LA" /></Link>
                    </div>
                    <div className='img-wrapper'>
                      <img src="images/web-new-images/icons/course-img.svg" alt="book" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className='courseOuter'>
                  <div className="courseCntnt">
                    <div>
                      <p>NAATI</p>
                      <Link to="/naati-coaching-classes-parramatta" className="primary-border-btn">VIEW COURSE <img className="arrow-icon" src="/images/web-new-images/icons/right-arrow.png" alt="LA" /></Link>
                    </div>
                    <div className='img-wrapper'>
                      <img src="images/web-new-images/icons/course-img.svg" alt="book" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className='courseOuter'>
                  <div className="courseCntnt">
                    <div>
                      <p>IELTS</p>
                      <Link to="/ielts-coaching-parramatta" className="primary-border-btn">VIEW COURSE <img className="arrow-icon" src="/images/web-new-images/icons/right-arrow.png" alt="LA" /></Link>
                    </div>
                    <div className='img-wrapper'>
                      <img src="images/web-new-images/icons/course-img.svg" alt="book" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Link to="/auth/register" className="primary-btn">REGISTER NOW</Link>
          </div>
        </div>
      </div>
    </section>
	);
}
}
export default coursesWeOffer;